<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <el-col :span="22">
      <el-form-item :label="$t('SettingBaseDataAfterSalesReason.table.code')" prop="reasonCode">
        <BjInput
          v-model="form.reasonCode"
          disabled
          :placeholder="$t('SettingBaseDataAfterSalesReason.table.generated')"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('SettingBaseDataAfterSalesReason.table.description')" prop="reasonDescribe">
        <BjInput
          v-model="form.reasonDescribe"
          :placeholder="$t('inputText')"
          clearable
        />
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { baseDataApi } from '@/api';
const getDefaultForm = () => {
  return {
    _innerMap: {},
    reasonCode: null,
    reasonDescribe: null,
    type: null,
    status: 1,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        reasonDescribe: [{ required: true, message: this.$t('SettingBaseDataAfterSalesReason.table.descriptionText'), trigger: 'blur' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    afterUpload(res) {
      this.form.logo = res;
    },
    show(info) {
      if (info) {
        this.isEdit = !!info.id;
      }
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('SettingBaseDataAfterSalesReason.table.editAfterSales') : this.$t('SettingBaseDataAfterSalesReason.table.newAfterSales'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }

      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    addApi(API_DATA) {
      baseDataApi.addAfterSalesReasons(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      baseDataApi.updateAfterSalesReasons(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
